import { render, staticRenderFns } from "./ThicknessNew.vue?vue&type=template&id=26af5096"
import script from "./ThicknessNew.vue?vue&type=script&lang=js"
export * from "./ThicknessNew.vue?vue&type=script&lang=js"
import style0 from "./ThicknessNew.vue?vue&type=style&index=0&id=26af5096&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports